<template>
    <Toast />
    <div class="row">
        <div class="col">
            <h2 class="titre">Modification Mandat PSU</h2>
        </div>
    </div>
    <ModifierChamps ref="modifierChamps" :mandat="mandat" :isModifier="true"/>
    <ButtonBar @sauvegarder="sauvegarder" @fermer="fermer" :isSauvegardeEnCours="isSauvegardeEnCours"/>
    <DialogConfirmation ref="dialogConfirmation" />     
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import ButtonBar from '../../../components/dossier/Modifier/ButtonBar.vue'
import ModifierChamps from '../../../components/dossier/Modifier/ModifierChampsMandatPSU.vue'
import DialogConfirmation from '../../../components/Commun/DialogConfirmation.vue'

export default {
    components: {
        ButtonBar,
        ModifierChamps,
        DialogConfirmation,
    },
    data() {
        return {
            isSauvegardeEnCours: false,
        }
    },
    computed: {
        ...mapGetters({
            jeton: 'cardex/jeton',
      profil: 'cardex/profil',
            mandat: 'mandatPSU/mandat'
        })
    },
    mounted() {

    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
        this.$root.$refs.breadcrumbComp.ajout("Modifier un Mandat PSU");
    },
  methods: {
    addMessage(messageList) {
        this.$root.$refs.messagesComp.messagesList = messageList
    },     
    sauvegarder() {
        this.isSauvegardeEnCours = true;
        this.$store.commit('mandatPSU/UPDATE_MANDAT',this.$refs.modifierChamps.getMandatLocal());             
        this.$store.dispatch('mandatPSU/sauvegarderMandatPSUAction', {
            cle: this.$route.params.cle,
            site: this.$route.params.site,
        }).then((res) =>{
            this.addMessage(res.data.messages)
            if (res?.data?.messages.length == 0) {
                this.$toast.add(
                {severity:'success', 
                summary: 'Modifier', 
                detail:"Le mandat PSU a été modifié.", 
                life: 6000});
            }                 
            this.isSauvegardeEnCours = false;
        });
    }, 
    fermer() {
        this.$root.$refs.breadcrumbComp.rediriger();           
    },                  
  },
  beforeRouteLeave (to, from, next) {
    return this.$refs.dialogConfirmation.confirmer(next, this.mandat,
     this.$refs.modifierChamps.getMandatLocal());
  },   
};

</script>
